import { cx } from '@lastbrand/web-ui-styled-system/css'

import { styledPageHeaderClass, textClass, titleClass } from './page-header-ds-styles'

import type { ReactNode } from 'react'

export interface PageHeaderProps {
  className?: string
  title?: string
  text?: ReactNode
}

// Render the description only when text is present. Legacy always emitted the div, leaving an empty node
// whose phantom margin drove spacing on text-less pages; the title→body gap now lives on styledPageHeaderClass.
const PageHeaderDS = ({ className, title, text }: PageHeaderProps) => (
  <div className={cx(styledPageHeaderClass, className)}>
    <h1 className={titleClass}>{title}</h1>
    {text ? <div className={textClass}>{text}</div> : null}
  </div>
)

export default PageHeaderDS
